import {
  AfterContentInit,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Input, OnDestroy,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {ChartAmchartLineComponent} from './chart-amchart-line/chart-amchart-line.component';
import {ChartAmchartColumnComponent} from './chart-amchart-column/chart-amchart-column.component';
import {GenericChartModel} from './generic-chart.model';
import {Graph} from '../../models/graph';
import {TYPE_GRAPH} from '../../models/type-graph.enum';
import {NoResults} from '../../models/no-results';

export type IScoringGraphicInject = { [K in TYPE_GRAPH]?: ComponentRef<GenericChartModel> };
export interface IstateMachine {
  isDataPresent: boolean;
  isError: boolean;
  isLoading: boolean;
  isEdit?: boolean;
}

@Component({
  selector: 'cmp-chart',
  template: `<span [hidden]="!stateChartMachine?.isDataPresent" #chartComponent></span>
<ng-container *ngIf="stateChartMachine?.isLoading">
  <!-- TODO by xinaski-->
  <div class="">
    <div class="">
      <div class="inner text-center">
        <i class="fa fa-spinner text-primary fa-2x fa-pulse fa-fw"></i>
        <h3 class="no-results text-primary">Loading</h3>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="stateChartMachine?.isError">
  <cmp-not-results
    [noResults]="noResults">
  </cmp-not-results>
</ng-container>
`,
  styles: [`.outer{display:table;position:absolute;height:100%;width:100%}.middle{display:table-cell;vertical-align:middle}.inner{margin-left:auto;margin-right:auto}`]
})
export class ChartComponentComponent implements AfterContentInit, OnDestroy {

  stateChartMachine: IstateMachine = {
    isDataPresent: false,
    isError: false,
    isLoading: false
  };

  chartSubject = new BehaviorSubject(false);
  chartSubjectSubscription: Subscription;
  scoringGraphicComponentInject: IScoringGraphicInject = {};

  scoringGraphicFactoryComponent = {
    [TYPE_GRAPH.MULTISERIE]: ChartAmchartLineComponent,
    [TYPE_GRAPH.SINGLESERIE]: ChartAmchartLineComponent,
    [TYPE_GRAPH.LINE]: ChartAmchartLineComponent,
    [TYPE_GRAPH.COLUMNS]: ChartAmchartColumnComponent,
    [TYPE_GRAPH.BAR]: ChartAmchartColumnComponent,
  };

  @Input() graphData: Graph;
  @Input() noResults: NoResults;

  @Input() set stateChartMachineData(its: IstateMachine) {
    if (its != null) {
      this.stateChartMachine = its;
      if (this.stateChartMachine.isDataPresent) {
        this.chartSubject.next(true);
      }
    }
  }

  @ViewChild('chartComponent', {read: ViewContainerRef}) chartComponent: ViewContainerRef;

  constructor(protected resolver: ComponentFactoryResolver) {
  }

  ngAfterContentInit() {
    this.chartSubjectSubscription = this.chartSubject
      .pipe(
        filter(Boolean)
      )
      .subscribe((res) => {
        this.setDynamicChartComponent();
      });
  }

  ngOnDestroy() {
    if (this.chartSubjectSubscription) {
      this.chartSubjectSubscription.unsubscribe();
    }
  }

  setDynamicChartComponent() {
    if (this.graphData && this.graphData.noResults && this.graphData.noResults.isError) {
      this.setInjectedComponentNoResults();
    } else {
      this.setInjectedComponent();
    }
  }

  setInjectedComponentNoResults() {
    if (this.chartComponent) {
      this.graphData.type = TYPE_GRAPH.LINE;
      this.resolveComponent();
      this.setWithError();
    }
  }

  setInjectedComponent() {
    if (this.chartComponent) {
      this.resolveComponent();
      try {
        this.setWithoutError();
      } catch (err) {
        this.setWithError();
      }
    }
  }

  resolveComponent() {
    try {
      this.scoringGraphicComponentInject[this.graphData.type] = this.chartComponent.createComponent(
        this.resolver.resolveComponentFactory(
          this.scoringGraphicFactoryComponent[this.graphData.type]
        )
      );
    } catch(e) {
    }
  }

  setWithoutError() {
    try {
      this.scoringGraphicComponentInject[this.graphData.type].instance.setGraphDataVariable(this.graphData);
      this.scoringGraphicComponentInject[this.graphData.type].instance.setData(this.graphData.config);
      this.scoringGraphicComponentInject[this.graphData.type].instance.getData(this.graphData.graph.series);
      this.scoringGraphicComponentInject[this.graphData.type].instance.setBuildData();
      this.scoringGraphicComponentInject[this.graphData.type].instance.setLoading(false);
    } catch (e) {
    }
  }


  setWithError() {
    try {
      this.scoringGraphicComponentInject[this.graphData.type].instance.setGraphDataVariable(this.graphData);
      this.scoringGraphicComponentInject[this.graphData.type].instance.setError(this.graphData.noResults);
      this.scoringGraphicComponentInject[this.graphData.type].instance.setLoading(false);
    } catch(e) {
    }
  }
}
